// Temporary fix: Move ArtMapDemo from save to pages
import React from "react";

const ArtMapDemo = () => {
  return (
    <div>
      <h1>Art Map Demo</h1>
      {/* Add your ArtMapDemo content here */}
    </div>
  );
};

export default ArtMapDemo;
